import { useEffect, useState } from 'react'
import { db } from '../firebase/config'

// Live subscription on the whole PlatformStats collection — the monthly
// history docs ({YYYY-MM}, written nightly by computePlatformStats) plus the
// `current` singleton, which buildPlatformStatSeries filters out on its
// missing `Period`. Same deliberate exception to
// #database-missing-compagnyid-on-fresh-fetch as usePlatformStats: these are
// system-level aggregate docs with no CompagnyID to scope by and no Deleted
// lifecycle; the Console rule (auth-only read, `{docId}` wildcard) covers the
// collection query. Deliberately NO orderBy('Period') — that would silently
// exclude docs missing the field (#database-firestore-orderby-excludes-missing-field);
// sorting happens client-side in buildPlatformStatSeries. ~12 docs/year.
//
// AI-CONTEXT: See docs/features/platform-stats-trend-sparklines.md
const usePlatformStatsHistory = () => {
    const [history, setHistory] = useState(/** @type {Array<object>} */ ([]))
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const unsubscribe = db.collection('PlatformStats').onSnapshot(
            (snapshot) => {
                setHistory(snapshot.docs.map((doc) => doc.data()))
                setLoading(false)
            },
            (error) => {
                console.error('usePlatformStatsHistory error:', error)
                setHistory([])
                setLoading(false)
            },
        )
        return unsubscribe
    }, [])

    return { history, loading }
}

export default usePlatformStatsHistory
